<!-- Sidebar navigation item.
     Active state uses sidebar-specific CSS variables.
     routerLinkActive applies active styling automatically. -->
<a
  [routerLink]="routerLink || null"
  routerLinkActive="nav-item--active"
  [routerLinkActiveOptions]="{ exact: false }"
  class="nav-item"
>
  <ng-icon [name]="icon" size="18" class="nav-item__icon"></ng-icon>
  <span class="nav-item__label"><ng-content></ng-content></span>
</a>
